import React, { Component } from 'react';
import {
    Info,
    LoginWrapper,
    LoginButtons,
    FinishIcon,
    FinishTip,
} from '../login/LoginStyle';
const finishIcon = require('../../images/finish.svg');

export default class CancellationOK extends Component {
    goLogout = () => {
        window.ReactNativeWebView.postMessage(JSON.stringify({ type: "logout" }));
    }
    render() {
        return (
            <LoginWrapper>
                <FinishIcon><img src={finishIcon} alt="成功" /></FinishIcon>
                <FinishTip>注销申请提交成功<br />账户已经被锁定</FinishTip>
                <Info>工作人员将在3个工作日内完成审核<br />并处理您的注销申请</Info>
                <LoginButtons onClick={this.goLogout}>退出登陆</LoginButtons>
            </LoginWrapper>
        )
    }
}